import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Link, Route, Routes } from "react-router-dom";
import { ErroHttp } from "./api/cliente";
import { AuthProvider } from "./auth/AuthProvider";
import { AvisosProvider } from "./components/Avisos";
import { Layout, LayoutSemMoldura, RotaAdmin } from "./components/Layout";
import { ContaSenha, EsqueciSenha, Login, Registrar } from "./pages/Acesso";
import { DiarioEditor } from "./pages/DiarioEditor";
import { DiarioImprimir } from "./pages/DiarioImprimir";
import { Diarios } from "./pages/Diarios";
import { Usuarios } from "./pages/Usuarios";
import "./styles/style.css";
import "./styles/complemento.css";
import "./styles/diario.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (tentativas, erro) => !(erro instanceof ErroHttp && erro.status < 500) && tentativas < 2,
    },
  },
});

function NaoEncontrado() {
  return (
    <>
      <h1>Página não encontrada</h1>
      <p className="note">
        <Link to="/">Voltar aos diários</Link>
      </p>
    </>
  );
}

createRoot(document.getElementById("raiz")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AvisosProvider>
          <AuthProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/registrar" element={<Registrar />} />
              <Route path="/esqueci-senha" element={<EsqueciSenha />} />
              <Route element={<LayoutSemMoldura />}>
                <Route path="/diarios/:id/imprimir" element={<DiarioImprimir />} />
              </Route>
              <Route element={<Layout />}>
                <Route index element={<Diarios />} />
                <Route path="/diarios" element={<Diarios />} />
                <Route path="/diarios/:id" element={<DiarioEditor />} />
                <Route path="/conta/senha" element={<ContaSenha />} />
                <Route element={<RotaAdmin />}>
                  <Route path="/usuarios" element={<Usuarios />} />
                </Route>
                <Route path="*" element={<NaoEncontrado />} />
              </Route>
            </Routes>
          </AuthProvider>
        </AvisosProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
